import { jsx as i, jsxs as p } from "react/jsx-runtime";
import Ye, { createContext as Qe, useState as z, useRef as c, useEffect as g, useCallback as Oe, useMemo as Ae } from "react";
import { useJsApiLoader as et } from "@react-google-maps/api";
import { renderToString as P } from "react-dom/server";
import { GOOGLE_MAPS_LIBRARIES as tt, GOOGLE_MAPS_LOADER_ID as nt } from "../../../config/googleMaps.js";
import rt from "./RadioPin.js";
import { useCenterMarker as ot, useMarkerCluster as at, convertSvgToUrl as it, getLatLng as Be, generateAddress as De, findOverlappingMarkers as Ge, resetMarkerToCenter as st, useMapControls as ct } from "./hooks.js";
import { markersRenderEqual as lt, circlesRenderEqual as dt } from "./markerCompare.js";
const ut = "data:image/svg+xml,%3csvg%20width='26'%20height='26'%20viewBox='0%200%2026%2026'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20opacity='0.3'%20cx='13'%20cy='12'%20r='12'%20fill='%236393F2'/%3e%3cg%20filter='url(%23filter0_d_11_548)'%3e%3ccircle%20cx='13'%20cy='12'%20r='5'%20fill='%236393F2'/%3e%3ccircle%20cx='13'%20cy='12'%20r='6'%20stroke='white'%20stroke-width='2'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_d_11_548'%20x='0'%20y='0'%20width='26'%20height='26'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='1'/%3e%3cfeGaussianBlur%20stdDeviation='3'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.15%200'/%3e%3cfeBlend%20mode='normal'%20in2='BackgroundImageFix'%20result='effect1_dropShadow_11_548'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='effect1_dropShadow_11_548'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", _e = {
  // name: "20972 Saratoga Hills Rd, Saratoga, CA 95070, USA",
  lat: 37.26534961208239,
  lng: -122.04076419999998
}, pt = /* @__PURE__ */ i("button", { className: "custom-map-control-button", title: "Reset to Center", children: /* @__PURE__ */ i("svg", { xmlns: "http://www.w3.org/2000/svg", height: "16px", width: "16px", viewBox: "0 -960 960 960", fill: "#000", children: /* @__PURE__ */ i("path", { d: "M480-400q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0 280q-139 0-241-91.5T122-440h82q14 104 92.5 172T480-200q117 0 198.5-81.5T760-480q0-117-81.5-198.5T480-760q-69 0-129 32t-101 88h110v80H120v-240h80v94q51-64 124.5-99T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-120Z" }) }) }), ft = `
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: bold;
  font-family: Arial, sans-serif;
  margin-top: 2px;
  white-space: nowrap;
  text-align: center;
`;
function qe(s, d) {
  return s.filter((v) => d.some((e) => e.markerId === v.id));
}
function F(s) {
  const v = s._domListeners;
  v && s.content && (s.content.removeEventListener("mouseenter", v.onEnter), s.content.removeEventListener("mouseleave", v.onLeave)), google.maps.event.clearInstanceListeners(s), s.map = null;
}
function ue(s) {
  const d = s.get("text");
  d && (google.maps.event.clearInstanceListeners(d), d.setMap(null)), google.maps.event.clearInstanceListeners(s), s.setMap(null);
}
function ze(s) {
  const d = s.domEvent?.target;
  return d instanceof Element ? !!(d.closest("[data-h9-map-marker]") || d.closest("gmp-advanced-marker")) : !1;
}
const Pe = Qe(void 0), bt = () => {
  const s = Ye.useContext(Pe);
  if (s === void 0)
    throw new Error("useMapContext must be used within a MapProvider");
  return s;
}, Lt = ({
  children: s,
  ...d
}) => {
  const {
    isLoaded: v
  } = et({
    id: nt,
    googleMapsApiKey: d.apiKey,
    libraries: tt
  }), [e, $e] = z(void 0), $ = c(void 0), R = c(void 0), U = c([]), Z = c([]), K = c(void 0), X = c(""), J = c(!1), O = c(null), T = c([]), k = c([]), I = c(null), Je = c(/* @__PURE__ */ new Map()), A = c(null), {
    center: N,
    zoom: B,
    showCurrentLocation: pe,
    showCenterMarker: He = !1,
    mapDraggable: fe = !0,
    markers: x,
    getMarkerData: ge,
    onMarkerClick: me,
    onMarkerHover: he,
    onMarkerHoverLeave: ve,
    enableCluster: H = !1,
    selectedID: f,
    markerDraggable: V = !0,
    overrideDrag: Y = !0,
    mapType: xe = "roadmap",
    hideTooltip: Q = !1,
    getMapData: Me,
    circles: D = [],
    showResetControl: we = !1,
    showMetaDataTooltip: ee = !0,
    doNotGenerateAddress: Ce = !1,
    setMapType: be,
    geoJson: te,
    geoJsonStyle: W,
    onGeoJsonClick: ne,
    onGeoJsonHover: re,
    onGeoJsonHoverLeave: oe
  } = d, [L, ae] = z(N ?? _e), [G, Le] = z(B ?? 10), [j, ye] = z([]), [S, We] = z(void 0), ie = c(Me);
  ie.current = Me;
  const se = c(me);
  se.current = me;
  const ce = c(he);
  ce.current = he;
  const Ee = c(ve);
  Ee.current = ve;
  const le = c(ge);
  le.current = ge;
  const Re = c(be);
  Re.current = be, v && !A.current && (A.current = new google.maps.InfoWindow({
    content: "",
    headerDisabled: !0,
    maxWidth: 450,
    minWidth: 250
  }));
  const M = A.current;
  g(() => {
    e && (R.current && R.current !== e && (T.current.forEach(F), T.current = [], k.current.forEach(ue), k.current = []), U.current = [], Z.current = [], K.current = void 0, X.current = "", A.current?.close(), ye([]), R.current = e);
  }, [e]), g(() => () => {
    T.current.forEach(F), T.current = [], k.current.forEach(ue), k.current = [], A.current?.close(), A.current = null, O.current?.setMap(null), O.current = null;
  }, []), g(() => {
    e && (N?.lat !== L.lat || N.lng !== L.lng) && ae(N ?? _e);
  }, [N, e]), g(() => {
    !e || B === void 0 || B !== G && Le(B);
  }, [B, e]), ot(He, e, L, ae);
  const je = at(H, e, j), de = Oe(() => {
    navigator.geolocation && navigator.geolocation.getCurrentPosition((r) => {
      const n = r.coords.latitude, t = r.coords.longitude;
      We((m) => m?.lat === n && m?.lng === t ? m : {
        lat: n,
        lng: t
      });
    });
  }, []);
  g(() => {
    if (!pe) return;
    de();
    const r = setInterval(de, 6e4);
    return () => clearInterval(r);
  }, [de, pe]), g(() => {
    if (!(!S || !e))
      return O.current?.setMap(null), O.current = new google.maps.Marker({
        position: S,
        map: e,
        title: "Current Location",
        icon: {
          url: ut,
          scaledSize: new google.maps.Size(30, 30),
          anchor: new google.maps.Point(15, 15)
        }
      }), () => {
        O.current?.setMap(null), O.current = null;
      };
  }, [S, e]), g(() => {
    if (!e || !x || !M) return;
    let r = !1;
    return (async () => {
      const {
        AdvancedMarkerElement: n
      } = await google.maps.importLibrary("marker");
      if (r) return;
      const t = `${V}|${Y}|${H}|${Q}|${ee}`;
      if (R.current === e && lt(U.current, x) && K.current === f && X.current === t) return;
      je.current?.clearMarkers(), T.current.forEach(F), T.current = [];
      const m = Je.current, _ = x.map((a) => {
        const q = f ? f === a.id : V, ke = `${a.radioType ?? "default"}-${q ? "d" : "s"}`;
        let y = a.icon;
        if (!y) {
          const o = m.get(ke);
          o ? y = o : (y = it(/* @__PURE__ */ i(rt, { type: a.radioType, parameters: {
            angle: 0,
            beamwidth: 0,
            gain: 30,
            health: q ? "GOOD" : "NA",
            channelColor: q ? "#34A853" : "#9E9E9E",
            network: "4G"
          } })), m.set(ke, y));
        }
        function Ze(o, E, w) {
          const C = document.createElement("div");
          C.dataset.h9MapMarker = "true", C.style.cssText = "position:relative;display:flex;flex-direction:column;align-items:center;overflow:hidden;z-index:1";
          const b = document.createElement("img");
          b.src = E;
          const h = w ? "80px" : "60px";
          if (b.style.width = h, b.style.height = h, b.alt = o.title || o.label || "", b.style.display = "block", C.appendChild(b), o.label) {
            const u = document.createElement("div");
            u.textContent = o.label, u.style.cssText = ft, C.appendChild(u);
          }
          if (o.badge) {
            const u = document.createElement("div");
            u.textContent = o.badge.text, u.style.cssText = `
              position: absolute;
              bottom: 2px;
              left: 50%;
              transform: translateX(-50%);
              min-width: 18px;
              height: 18px;
              border-radius: 9px;
              background-color: ${o.badge.color ?? "#1976d2"};
              color: ${o.badge.textColor ?? "white"};
              font-size: 10px;
              font-weight: bold;
              font-family: Arial, sans-serif;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0 4px;
              box-shadow: 0 1px 3px rgba(0,0,0,0.3);
              pointer-events: none;
            `, C.appendChild(u);
          }
          return C;
        }
        const Ke = Ze(a, y, f === a.id), Xe = Number(google.maps.Marker.MAX_ZINDEX ?? 0) + (q ? 2 : 1), l = new n({
          position: a.location,
          title: a.title || a.label,
          map: H ? null : e,
          content: Ke,
          gmpDraggable: Y ? q : !1,
          gmpClickable: !0,
          zIndex: Xe
        });
        Object.defineProperty(l, "markerId", {
          value: a.id,
          writable: !1
        }), Object.defineProperty(l, "metadata", {
          value: a.metadata,
          writable: !1
        }), f === a.id && ($.current = l), l.addListener("dragend", async () => {
          const o = Be(l.position);
          if (!o?.lat || !o?.lng) {
            console.error("Invalid marker position at marker instance dragend:", l.position);
            return;
          }
          const E = await De(o.lat, o.lng);
          le.current?.({
            id: a.id,
            location: {
              lat: o.lat,
              lng: o.lng,
              address: E
            }
          });
        }), l.addListener("gmp-click", () => {
          if (J.current = !0, window.setTimeout(() => {
            J.current = !1;
          }, 0), !se.current) return;
          const o = Ge(l, _, e);
          se.current(a, qe(x, o), f === a.id);
        });
        const Ie = () => {
          if (Q) return;
          const o = Ge(l, _, e);
          if (o.length > 0) {
            const E = o.slice(0, 6), w = o.length - E.length;
            M.setContent(P(/* @__PURE__ */ p("div", { className: "map-tooltip-div", children: [
              /* @__PURE__ */ p("div", { className: "tooltip-subtitle", children: [
                "Multiple at this location (",
                o.length + 1,
                ")"
              ] }),
              /* @__PURE__ */ p("ul", { className: "overlapping-markers", children: [
                /* @__PURE__ */ p("li", { className: "overlapping-marker", children: [
                  /* @__PURE__ */ i("img", { src: y, alt: a.title, className: "tooltip-icon" }),
                  /* @__PURE__ */ i("span", { children: a.title })
                ] }),
                E.map((C, b) => {
                  const h = x.find((u) => C.markerId === u.id);
                  return /* @__PURE__ */ p("li", { className: "overlapping-marker", children: [
                    /* @__PURE__ */ i("img", { className: "tooltip-icon", src: h?.icon ?? y, alt: h?.title }),
                    /* @__PURE__ */ i("span", { children: h?.title })
                  ] }, b);
                }),
                w > 0 && /* @__PURE__ */ i("li", { className: "overlapping-marker more-markers", children: /* @__PURE__ */ p("span", { children: [
                  "+",
                  w,
                  " more"
                ] }) })
              ] })
            ] })));
          } else if (a.tooltipRender)
            M.setContent(P(/* @__PURE__ */ i("div", { className: "map-tooltip-div", children: a.tooltipRender(a, o) })));
          else {
            let E = function(w, C, b) {
              return P(/* @__PURE__ */ p("div", { className: "map-tooltip-div", children: [
                /* @__PURE__ */ p("div", { className: "tooltip-header", children: [
                  /* @__PURE__ */ i("img", { src: C, alt: w.title, className: "tooltip-icon" }),
                  /* @__PURE__ */ i("div", { children: /* @__PURE__ */ i("div", { className: "tooltip-title", children: w.title }) })
                ] }),
                b && /* @__PURE__ */ p("div", { children: [
                  /* @__PURE__ */ i("div", { className: "tooltip-section-title", children: "Details" }),
                  Array.isArray(w.metadata) ? w.metadata.map((h, u) => /* @__PURE__ */ i("div", { className: "tooltip-data-card", children: /* @__PURE__ */ i("div", { className: "tooltip-data-grid", children: Object.entries(h).map(([Se, Ve]) => /* @__PURE__ */ p("div", { children: [
                    /* @__PURE__ */ p("span", { className: "tooltip-data-label", children: [
                      Se,
                      ":"
                    ] }),
                    " ",
                    /* @__PURE__ */ i("span", { className: "tooltip-data-value", children: Ve })
                  ] }, Se)) }) }, u)) : /* @__PURE__ */ i("div", { className: "tooltip-data-card", children: /* @__PURE__ */ i("div", { className: "tooltip-data-grid", children: Object.entries(w.metadata ?? {}).map(([h, u]) => /* @__PURE__ */ p("div", { children: [
                    /* @__PURE__ */ p("span", { className: "tooltip-data-label", children: [
                      h,
                      ":"
                    ] }),
                    " ",
                    /* @__PURE__ */ i("span", { className: "tooltip-data-value", children: u })
                  ] }, h)) }) })
                ] })
              ] }));
            };
            M.setContent(E(a, y, ee));
          }
          M.open({
            anchor: l
          }), ce.current && ce.current(a, qe(x, o), f === a.id);
        }, Ne = () => {
          M.close(), Ee.current?.();
        };
        return l.content?.addEventListener("mouseenter", Ie), l.content?.addEventListener("mouseleave", Ne), l._domListeners = {
          onEnter: Ie,
          onLeave: Ne
        }, l;
      });
      if (r) {
        _.forEach(F);
        return;
      }
      T.current = _, ye(_), U.current = x, K.current = f, X.current = t, R.current = e;
    })(), () => {
      r = !0;
    };
  }, [
    // Handlers are read via refs and deliberately not deps
    v,
    e,
    V,
    x,
    H,
    Y,
    f,
    Q,
    ee
  ]), g(() => {
    if (!e || !D || !M || R.current === e && dt(Z.current, D)) return;
    k.current.forEach(ue), k.current = [];
    const r = D.map((n) => {
      const t = new google.maps.Circle({
        map: e,
        center: n.center,
        radius: n.radius,
        fillColor: n.color,
        strokeColor: n.color,
        fillOpacity: 0.4
      }), m = new google.maps.Marker({
        position: n.center,
        map: e,
        label: {
          text: n.count?.toString() ?? "",
          fontSize: "16px",
          fontWeight: "500",
          color: "#fff"
        },
        icon: {
          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <circle cx="15" cy="15" r="13.5" fill="${n.color}" stroke="white" stroke-width="3"/>
              </svg>`)}`
        },
        zIndex: 1e3
      });
      return t.addListener("mouseover", () => {
        M.setContent(P(/* @__PURE__ */ i("div", { className: "map-tooltip-div", style: {
          padding: "6px",
          marginBottom: "10px"
        }, children: n.tooltipRender?.(n) }))), M.open({
          anchor: m
        });
      }), t.addListener("mouseout", () => {
        M.close();
      }), t.set("text", m), t;
    });
    k.current = r, Z.current = D, R.current = e;
  }, [e, D]), g(() => {
    if (!e) return;
    const r = e.data;
    r.forEach((n) => {
      r.remove(n);
    }), te && r.addGeoJson(te), r.setStyle((n) => {
      const t = typeof W == "function" ? W(n) : W ?? {};
      return {
        ...t,
        // Keep GeoJSON below Advanced Markers; preserve relative order among features
        zIndex: t.zIndex ?? 0
      };
    });
  }, [e, te, W]), g(() => {
    if (!e) return;
    const r = e.data, n = [];
    return ne && n.push(r.addListener("click", (t) => {
      if (t.stop(), t.domEvent?.stopPropagation?.(), J.current || ze(t))
        return;
      const {
        feature: m
      } = t;
      window.setTimeout(() => {
        J.current || ne(m, t);
      }, 0);
    })), re && n.push(r.addListener("mouseover", (t) => {
      ze(t) || re(t.feature, t);
    })), oe && n.push(r.addListener("mouseout", () => {
      oe();
    })), () => {
      n.forEach((t) => t.remove());
    };
  }, [e, ne, re, oe]);
  const Fe = Ae(() => {
    if (!x?.length || !f || !we) return [];
    const r = document.createElement("div");
    return r.innerHTML = P(pt), r.onclick = () => {
      !e || !$.current || st(e, $.current, f, le.current);
    }, [r];
  }, [e, x?.length, f, we]);
  ct(e, Fe), g(() => {
    if (!e || !(j?.length > 1) || N) return;
    const r = new google.maps.LatLngBounds();
    j.forEach((n) => {
      const t = Be(n.position);
      if (!t?.lat || !t?.lng) {
        console.error("Invalid marker position at map fit bounds:", n);
        return;
      }
      t.lat !== 0 && t.lng !== 0 && r.extend(new google.maps.LatLng(t.lat, t.lng));
    }), e.fitBounds(r);
  }, [e, N, j]), g(() => {
    if (e && (I.current && (clearTimeout(I.current), I.current = null), !Ce && ie.current))
      return I.current = setTimeout(async () => {
        const r = await De(L.lat, L.lng), n = e.getBounds();
        ie.current?.({
          center: L,
          zoom: G,
          currentLocation: S,
          address: r,
          boundingBox: n ? {
            northWestBound: n.getNorthEast().toJSON(),
            southEastBound: n.getSouthWest().toJSON()
          } : void 0
        });
      }, 100), () => {
        I.current && (clearTimeout(I.current), I.current = null);
      };
  }, [L, G, S, e, Ce]);
  const Te = Oe(() => {
    Re.current?.(e?.getMapTypeId());
  }, [e]), Ue = Ae(() => ({
    isAPIloaded: v,
    center: L,
    setCenter: ae,
    zoom: G,
    setZoom: Le,
    mapRef: e,
    setMapRef: $e,
    selectedMarkerInstance: $,
    mapDraggable: fe,
    currentLocation: S,
    mapType: xe,
    handleMapTypeChange: Te
  }), [v, L, G, e, fe, S, xe, Te]);
  return /* @__PURE__ */ i(Pe.Provider, { value: Ue, children: s });
};
export {
  Lt as MapProvider,
  bt as useMapContext
};
